import React from "react";
import signInActions from "../data/signInActions"

const Header = (props) => {
  const [collapsed, setCollapsed] = React.useState(false);

  const linkClickHandler = (e) => {
    e.preventDefault();
    if (e.target.name) {
      props.history.push(e.target.name);
    } else {
      props.history.push("/");
    }
  };


  return (
    <nav className="navbar navbar-dark navbar-expand-lg p-2 bg-primary ">
      <a name="/" onClick={linkClickHandler} className="navbar-brand" href="/">
        Instance manager
      </a>
      <button
        className="navbar-toggler"
        type="button"
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div
        className={collapsed ? "navbar-collapse" : "collapse navbar-collapse"}
        style={{ justifyContent: "flex-end" }}
        id="navbarNavAltMarkup"
      >
        <div className="navbar-nav text-right">
        <a
            name="/generalSettings"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            Settings
          </a>
        <a
            name="/dbDump"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            DB Dump
          </a>
        <a
            name="/dbRestore"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            DB Restore
          </a>
        <a
            name="/hologicweb/deploy"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            Hologic Web
          </a>
        <a
            name="/billing"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            Billing 
          </a>
          <a
            name="/licences"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            Licences 
          </a>


          <a
            name="/instances"
            onClick={linkClickHandler}
            className="nav-item nav-link"
            href="/"
          >
            Instances
          </a>

          <a onClick={signInActions.logout} className="nav-item nav-link" href="/">
            Log out
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;